// extracted by mini-css-extract-plugin
export var modal = "_sq-0";
export var table = "_sq-1";